import {
  type GroundCancelScenario,
  GroundCancelScenarioEnum,
} from "@b2bportal/ground-api";
import {
  type GroundCancelScenarioV2,
  GroundCancelScenarioV2Enum,
} from "@b2bportal/rbc-ground-cancel-v2-api";

// Maps a v1 ground cancel scenario onto the v2 discriminated shape so the
// downstream v2-typed components can render the v1 fallback path correctly.
// v1 scenarios carry cancelCopy/importantInfo directly on the object; v2 may
// nest copy under `condition` for RefundableWithConditions (handled by the
// getCancelCopy helper in CarTripCancellationPolicy). For all scenarios that
// exist in v1, the fields are structurally compatible after the discriminator
// is added, so the cast is safe at runtime.
export function adaptV1ScenarioToV2(
  v1: GroundCancelScenario
): GroundCancelScenarioV2 {
  const scenarioMap: Partial<Record<string, GroundCancelScenarioV2Enum>> = {
    [GroundCancelScenarioEnum.FullyRefundable]:
      GroundCancelScenarioV2Enum.FullyRefundable,
    [GroundCancelScenarioEnum.NonRefundable]:
      GroundCancelScenarioV2Enum.NonRefundable,
    [GroundCancelScenarioEnum.ContactCustomerService]:
      GroundCancelScenarioV2Enum.ContactCustomerService,
    [GroundCancelScenarioEnum.Canceled]: GroundCancelScenarioV2Enum.Canceled,
    [GroundCancelScenarioEnum.Pending]:
      GroundCancelScenarioV2Enum.BookingPending,
  };
  return {
    ...v1,
    // Fall back to ContactCustomerService for any unknown v1 scenario so the
    // discriminator is always a valid v2 value.
    GroundCancelScenarioV2:
      scenarioMap[v1.GroundCancelScenario] ??
      GroundCancelScenarioV2Enum.ContactCustomerService,
  } as unknown as GroundCancelScenarioV2;
}
